module.exports = __webpack_public_path__ + "static/media/news.ace450ef.svg";